// extracted by mini-css-extract-plugin
export default {"zoomModal":"m4-z"};